export default {
    Menu: 'Menu',
    Add: 'Aggiungi',
    Modify: 'Modifica',
    Delete: 'Elimina',
    Scale: 'Ridimensiona',
    Color: 'Colore',
    Materials: 'Materiali',
    Mesh: 'Mesh',
    Size: 'Dimensione',
    Details: 'Dettagli',
    Quantity: 'Quantità',
    AddToCart: 'Aggiungi al carrello',
    AddToCartTitle: 'Aggiungi al carrello',
    Cart: 'Carrello',
    Total: 'Totale',
    Subtotal: 'Subtotale',
    Shipping: 'Spedizione',
    Shape: 'Forma',
    PickShape: 'Scegli una forma da aggiungere alla tela',
    ShapeAdded: 'Forma aggiunta. Clicca su un\'altra per sostituirla.',
    Clipart: 'Illustrazione',
    PickClipart: 'Scegli un\'illustrazione da aggiungere alla tela',
    ClipartAdded: 'Illustrazione aggiunta. Clicca su un\'altra per sostituirla.',
    SearchClipart: 'Cerca un\'illustrazione…',
    NoClipartFound: 'Nessuna illustrazione trovata',
    Cliparts: 'Clipart',
    Illustration: 'Illustrazione',
    AiImage: 'Immagine IA',
    AiImageIntro: 'Descrivi ciò che vuoi, scegli un formato e ottieni 2 proposte.',
    AiImageFormat: 'Formato',
    AiFormatSquare: 'Quadrato',
    AiFormatPortrait: 'Verticale',
    AiFormatLandscape: 'Orizzontale',
    AiImagePlaceholder: 'Es.: una volpe rossa stilizzata, stile piatto, sfondo trasparente…',
    AiGenerate: 'Genera',
    AiGenerating: 'Generazione…',
    AiPickResult: 'Scegli una proposta',
    AiImageAdded: 'Immagine aggiunta alla tela',
    AiImageError: 'Generazione dell\'immagine non riuscita',
    AiNoResult: 'Nessuna immagine generata',
    AiImageNotInPlan: 'La generazione di immagini IA non è inclusa nel tuo piano. Attiva l\'opzione per usarla.',
    SearchIllustration: 'Cerca un\'illustrazione…',
    NoIllustrationFound: 'Nessuna illustrazione trovata',
    IllustrationIntro: 'Cerca illustrazioni vettoriali da aggiungere alla tela.',
    IllustrationError: 'Ricerca di illustrazioni non riuscita',
    IllustrationNotVector: 'Questo risultato non è un vettore utilizzabile',
    Texts: 'Testi',
    Images: 'Immagini',
    Colors: 'Colori',
    ThemeEditDesc: 'Modifica i testi, le immagini e i colori del tema.',
    ThemeNotFound: 'Tema non trovato.',
    ThemeNoEditable: 'Questo tema non contiene elementi modificabili.',
    Helpers: 'Righelli, guide e griglia',
    Rulers: 'Righelli',
    RulersHint: 'Graduazione in pixel',
    Guides: 'Guide',
    GuidesHint: 'Riferimenti al 25 / 50 / 75 %',
    GridHint: 'Griglia in sovrimpressione',
    Snapping: 'Aggancio',
    SnappingHint: 'Allinea al centro / griglia / altri oggetti',
    LeaveConfirm: 'Vuoi davvero perdere le tue modifiche?',
    Products: 'Prodotti',
    Customization: 'Personalizzazione',
    BackToCustomizationType: 'Tipo di personalizzazione',
    SaveNoChanges: 'Nessuna modifica da salvare',
    ChooseCategory: 'Scegli una categoria',
    SelectProduct: 'Scegli un prodotto',
    Loading: 'Caricamento',
    ProofLogoTooLarge: 'Logo troppo pesante (massimo 500 KB).',
    ProofLogoInvalidType: 'Formato immagine non supportato.',
    ProofLogoImported: 'Logo importato.',
    ProofLogoImportFailed: 'Importazione del logo non riuscita.',
    YouHaveProjects: 'Hai {count} progetto/i in corso',
    ResumeProject: 'Riprendi un progetto',
    ResumeProjectHint: 'Riprendi da dove avevi lasciato.',
    YourProjects: 'I tuoi progetti in corso',
    OpenProject: 'Apri questo progetto',
    NoProjects: 'Nessun progetto in corso.',
    AppUpdating: 'Aggiornamento dell\'applicazione…',
    DraftRestored: 'Bozza ripristinata',
    SaveExpiredTitle: 'Salvataggio scaduto',
    SaveExpiredMessage: 'Questo salvataggio è scaduto o non è più disponibile.',
    Continue: 'Continua',
    PhotoFramePickShape: 'Scegli una cornice',
    PhotoFramePlacePhoto: 'Posiziona e regola la tua foto',
    PhotoFrameChangePhoto: 'Cambia foto',
    PhotoFrameDropTitle: 'Trascina una foto qui',
    PhotoFrameDropSub: 'o clicca per caricare',
    Rotation: 'Rotazione',
    Reset: 'Reimposta',
    ProofLogoTitle: 'Logo della bozza',
    ProofLogoUseSite: 'Mantieni il logo di {site}',
    ProofLogoUseMine: 'Con il mio logo',
    ProofLogoUseMineDesc: 'Solo sulla bozza, non sui file di stampa.',
    ProofLogoNone: 'Senza alcun logo',
    ProofLogoDropTitle: 'Importa il tuo logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Convalida del tuo ordine',
    LoadingStepScreenshots: 'Generazione delle anteprime',
    LoadingStepPrintFile: 'Generazione dei file di stampa',
    LoadingStepUpload: 'Caricamento sul server',
    LoadingStepSave: 'Salvataggio della configurazione',
    LoadingGraduation: 'Caricamento della graduazione',
    OptimizingImage: 'Ottimizzazione dell\'immagine',
    LoadingScene: 'Caricamento della scena',
    LoadingStepZip: 'Creazione dello zip',
    LoadingProduct: 'Caricamento del prodotto',
    Category: 'Categoria',
    Product: 'Prodotto',
    Summary: 'Riepilogo',
    Zone: 'Zona',
    SelectZone: 'Seleziona una zona',
    SelectAZone: 'Scegli una zona',
    Undo: 'Annulla',
    Redo: 'Ripeti',
    Recenter: 'Centra la vista',
    HelpersIntro: 'Bordi delle zone, griglia, righelli e guide sulla tela 2D.',
    ShowZoneBordersHint: 'Cornici delle zone sulla tela principale',
    Save: 'Salva',
    Saving: 'Salvataggio',
    Grid: 'Griglia',
    SwitchTo3D: 'Passa a 3D',
    PrintZone: 'Area di stampa',
    ViewModeSwitch: 'Modalità di visualizzazione',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Doppia',
    ShowZoneBorders: 'Mostra il contorno delle zone',
    ShowZoneBordersHelp: 'Mostra/nasconde il contorno tratteggiato e l\'etichetta delle zone sulla tela 2D.',
    ManageElements: 'Gestisci gli elementi',
    StartWithTheme: 'Inizia con un tema',
    Customize: 'Personalizza',
    FromThemeLibrary: 'Dalla nostra libreria di temi',
    StartFromScratch: 'Inizia da zero',
    Or: 'oppure',
    PreviousCreations: 'Creazioni precedenti',
    WithModel: 'Con un modello',
    Search: 'Cerca',
    SubCategory: 'Sottocategoria',
    Next: 'Avanti',
    Previous: 'Indietro',
    Validate: 'Conferma',
    DownloadMyProject: 'Scarica il mio progetto',
    EditThemeColors: 'Modifica i colori degli elementi',
    AddPattern: 'Aggiungi uno sfondo',
    EditGraduation: 'Modifica la graduazione',
    Pattern: 'Sfondo',
    PatternHint: 'Il motivo viene ripetuto su tutta l\'area di personalizzazione. I suoi colori sono personalizzabili.',
    SearchTheme: 'Cerca un tema (titolo o tag)',
    Theme: 'Tema',
    Graduation: 'Graduazione',
    Graduation_s: 'Graduazione/i',
    ErrorOccurred: 'Si è verificato un errore.',
    ReloadPage: 'Ricarica la pagina.',
    LoadingCategories: 'Caricamento delle categorie',
    ShowAll: 'Mostra tutto',
    Categories: 'Categorie',
    ComingSoon: 'Prossimamente',
    DropImageHere: 'Trascina qui un\'immagine',
    ReleaseToImport: 'Rilascia per importare',
    OrClickToBrowse: 'oppure clicca per sfogliare',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Questo metodo di stampa funziona con colori definiti. Consigliamo file vettoriali per un risultato ottimale.',
    SearchInPhotoGallery: 'Cerca nella nostra galleria fotografica',
    QrCode: 'Codice QR',
    QrCodeContent: 'Contenuto (URL, testo, email…)',
    QrCodePlaceholder: 'https://esempio.com',
    QrCodeForeground: 'Colore QR',
    QrCodeBackground: 'Sfondo',
    QrCodeTransparentBg: 'Sfondo trasparente',
    QrCodeErrorLevel: 'Tolleranza agli errori',
    QrCodeErrorL: '7 % (densità bassa)',
    QrCodeErrorM: '15 % (standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (alta)',
    QrCodeEmptyPreview: 'Inserisci un contenuto per l\'anteprima',
    QrCodeRequired: 'Il contenuto del codice QR è obbligatorio.',
    QrCodeInvalidUrl: 'Inserisci un URL di codice QR valido (http:// o https://).',
    QrCodeAdd: 'Aggiungi il codice QR',
    QrCodeEditOnlyColors:
        'Dopo la creazione di un codice QR è possibile modificare solo i colori. Per cambiarne il contenuto, eliminalo e creane uno nuovo.',
    ImageQualityGood: 'Buona risoluzione',
    ImageQualityMedium: 'Risoluzione media',
    ImageQualityLow: 'Bassa risoluzione: ingrandisci l\'immagine o riducila sulla tela',
    LowQualityAlertTitle: 'Attenzione',
    LowQualityAlertMessage:
        'La tua creazione contiene immagini di bassa qualità o troppo ingrandite rispetto alla risoluzione originale. Devi correggere la creazione o accettare il rischio di pixelatura in stampa.',
    LowQualityAlertHint: 'Soglia di bassa risoluzione:',
    LowQualityAcceptRisk: 'Accetto il rischio di pixelatura per le mie immagini di bassa qualità',
    Preview: 'Anteprima',
    Bold: 'Grassetto',
    Italic: 'Corsivo',
    Underline: 'Sottolineato',
    FontSize: 'Dimensione',
    SelectFont: 'Scegli un carattere',
    UploadFont: 'Carica il mio font',
    UploadFontHint: 'TTF o OTF · max 5 MB',
    CustomFontBadge: 'propria',
    CustomFontImported: 'Font importato.',
    CustomFontFormatError: 'Formato non supportato (solo TTF o OTF).',
    CustomFontTooLarge: 'Font troppo grande (massimo 5 MB).',
    CustomFontImportFailed: 'Importazione del font non riuscita.',
    CustomFontRemoved: 'Font rimosso.',
    RecentFonts: 'Recenti',
    Clear: 'Cancella',
    TextColor: 'Colore del testo',
    TextOutline: 'Contorno',
    AddOutline: 'Aggiungi un contorno',
    RemoveOutline: 'Rimuovi il contorno',
    PickColor: 'Scegli un colore',
    PickThemeCategory: 'Scegli una categoria per esplorare i temi',
    NoThemeInCategory: 'Nessun tema in questa categoria',
    ThemePreviewLabel: 'Anteprima del tema',
    PickAnotherTheme: 'Scegli un altro tema',
    Keep: 'Mantieni',
    LoadingThemes: 'Caricamento dei temi',
    LoadingPatterns: 'Caricamento degli sfondi',
    EditableThemeColors: 'Colori modificabili degli elementi',
    PickAColor: 'Scegli un colore',
    SelectALayout: 'Seleziona un modello',
    CreateLayer: 'Crea un elemento',
    LastDownloads: 'Ultimi download',
    Cancel: 'Annulla',
    Back: 'Indietro',
    BackToProvider: 'Torna a {provider}',
    LayerNotFound: 'Elemento non trovato',
    ChangeImage: 'Cambia l\'immagine',
    ChangePattern: 'Cambia lo sfondo',
    Resize: 'Ridimensiona',
    RemoveBackground: 'Scontorna',
    Processing: 'Elaborazione…',
    AddFilter: 'Aggiungi un filtro',
    PhotoCredit: 'Foto di {author} su {provider}',
    PhotoBy: 'Foto di',
    On: 'su',
    LinkRedirectionWarning: 'Questo link ti reindirizzerà a questo sito web',
    LoadMore: 'Carica altro',
    EditLayer: 'Modifica l\'elemento',
    Import: 'Importa',
    FromYourDevice: 'Dal tuo dispositivo',
    FromImageGallery: 'Dalla galleria di immagini',
    NoGraduationsAvailable: 'Nessuna graduazione disponibile',
    Confirm: 'Conferma',
    CustomizeProduct: 'Personalizza il tuo prodotto',
    WriteYourText: 'Scrivi qui il tuo testo',
    Text: 'Testo',
    Image: 'Immagine',
    DesignSummary: 'Riepilogo del tuo design',
    AddOptions: 'Aggiungi opzioni',
    TermsOfSale: 'Condizioni generali di vendita',
    TOSMessage:
        'Certifico che la mia creazione è conforme alle [Condizioni generali di vendita](#) e in particolare all\'articolo 8 - Proprietà intellettuale',
    IValidateMyCreation: 'Confermo la mia creazione',
    FunctionalityNotAvailable: 'Funzionalità non disponibile',
    Lock: 'Blocca',
    Unlock: 'Sblocca',
    AddLayer: 'Aggiungi un elemento',
    LayerSectionTemplates: 'Modelli',
    LayerSectionText: 'Testo e dati',
    LayerSectionImages: 'Immagini',
    LayerSectionDecor: 'Decorazioni',
    LayerSectionTools: 'Strumenti',
    DragLayersToReorder: 'Trascina i livelli per riordinarli',
    PleaseAgreeTOS: 'Accetta le condizioni generali per confermare la tua creazione.',
    ErrorExportPrintFile: 'Si è verificato un errore durante l\'esportazione del file di stampa.',
    ErrorExportProofFile: 'Si è verificato un errore durante l\'esportazione della bozza di stampa.',
    ErrorAddToCart: 'Si è verificato un errore durante l\'aggiunta al carrello: ',
    Gabarit: 'Sagoma',
    FicheTechnique: 'Scheda tecnica',
    GeneratingPrintFile: 'Generazione del file di stampa…',
    GeneratingProofFile: 'Generazione della bozza di stampa…',
    LeaveCustomizer: 'Esci dal configuratore',
    LeaveManager: 'Esci dalla gestione degli elementi',
    ChangeProductTitle: 'La tua creazione verrà eliminata.',
    ChangeProductConfirm: 'Cambiare prodotto eliminerà definitivamente la tua creazione, sei sicuro?',
    Duplicate: 'Duplica',
    LoadingTheme: 'Caricamento del tema',
    LoadingPattern: 'Caricamento dello sfondo',
    Expand: 'Ingrandisci',
    Shrink: 'Riduci',
    TiltLeft: 'Inclina a sinistra',
    TiltRight: 'Inclina a destra',
    Rotate: 'Ruota',
    Move: 'Sposta',
    Reposition: 'Riposiziona',
    MoveUp: 'Sposta in alto',
    MoveDown: 'Sposta in basso',
    MoveLeft: 'Sposta a sinistra',
    MoveRight: 'Sposta a destra',
    NoCustomization: 'Non c\'è alcuna personalizzazione sul prodotto.',
    MissingCustomization: 'Personalizzazione mancante',
    SelectGraduation: 'Seleziona una graduazione',
    ProofTitle: 'Bozza di stampa',
    ProofDesignTitle: 'Personalizzazione 2D',
    ProofScreenshotsTitle: 'Viste 3D',
    ProofSelectedInksTitle: 'Colori selezionati',
    Warning: 'Attenzione',
    SelectZoneBeforeTheme: 'Seleziona una zona prima di scegliere un tema.',
    ThemeTooManyElements: 'Il tema contiene troppi elementi. Scegline un altro',
    Error: 'Errore',
    ProductNotFound: 'Prodotto non trovato',
    ProductNotFoundMessage: 'Prodotto non trovato, verrai reindirizzato alla home page.',
    NoCategoryAvailable: 'Nessuna categoria disponibile',
    CategoryNotFound: 'Categoria non trovata',
    CategoryNotFoundMessage: 'Categoria non trovata, verrai reindirizzato alla home page.',
    Unavailable: 'Non disponibile',
    SavedConfigurations: 'Configurazioni salvate',
    YourSavedConfigurations: 'Le tue configurazioni salvate',
    NoSavedConfigurations: 'Nessuna configurazione salvata per questo prodotto',
    ConfigurationName: 'Nome della configurazione',
    Created: 'Creato',
    Expires: 'Scade',
    Load: 'Carica',
    ConfirmDeleteConfiguration: 'Vuoi davvero eliminare questa configurazione?',
    Close: 'Chiudi',
    Step: 'Passo',
    CustomizeProductDesc: 'Scegli come iniziare: creazione libera o a partire da un tema proposto qui sotto.',
    StartFromScratchDesc: 'Una tela vuota per aggiungere testi, immagini e forme, senza modello imposto.',
    ChooseProductDesc: 'Scegli un prodotto da personalizzare.',
    PrintMethod: 'Metodo di stampa',
    ChoosePrintMethod: 'Scegli il tuo metodo',
    ChoosePrintMethodDesc:
        'Seleziona il metodo di stampa per questo prodotto. Questa scelta è definitiva per questa personalizzazione.',
    Digital: 'Digitale',
    ScreenPrinting: 'Serigrafia',
    LaserEngraving: 'Incisione laser',
    Embroidery: 'Ricamo',
    RestrictedToPalette: 'Colori limitati alla palette',
    ChooseInks: 'Scegli i tuoi inchiostri',
    ChooseThreads: 'Scegli i tuoi fili',
    AppliesToZone: 'Zona: {zone}',
    Ink: 'Inchiostro',
    Thread: 'Filo',
    InkOverride: 'Forza un inchiostro',
    ThreadOverride: 'Forza un filo',
    SuggestInks: 'Inchiostri suggeriti',
    SuggestThreads: 'Fili suggeriti',
    RecommendColorsFromImage: 'Consiglia colori dall\'immagine',
    NoColorSuggestion: 'Nessun suggerimento di colore per questa immagine.',
    InkAssistantHelp: 'Questo metodo utilizza una palette di {count} colori fissi.',
    InkAssistantQuestion: 'Come vuoi definire i tuoi colori?',
    InkAssistantUpload: 'Aiutami a trovare i miei colori',
    InkAssistantUploadDesc:
        'Importa la tua immagine, logo o motivo: rileviamo automaticamente i colori della palette più vicini.',
    InkAssistantManual: 'Scelgo i miei colori manualmente',
    InkAssistantManualDesc: 'Seleziona ogni colore, uno a uno, nella palette.',
    InkAssistantAnalyzing: 'Analisi della tua immagine…',
    InkChoiceModifiableHint: 'Questa scelta è modificabile in qualsiasi momento.',
    InkAssistantResultDesc: 'Ecco i colori della palette più vicini alla tua immagine.',
    InkDuplicateWarning:
        'Questo colore è già selezionato per un altro inchiostro / filo. Selezionarlo una seconda volta unirà i colori definitivamente. Sei sicuro?',
    Selected: 'Selezionato',
    VectorizeImage: 'Vettorializza l\'immagine',
    Vectorizing: 'Vettorializzazione…',
    VectorizePreviewTitle: 'Risultato della vettorializzazione',
    VectorizeIntro:
        'L\'immagine sarà convertita in vettore e limitata agli inchiostri scelti. Conferma il risultato per applicarlo.',
    VectorizeApply: 'Applica il vettore',
    VectorizeConsent:
        'Comprendo di essere responsabile del controllo del risultato della vettorializzazione e che la stampa ne sarà il riflesso.',
    VectorizeThreshold: 'Soglia (dettaglio / sfondo)',
    VectorizeThresholdHint:
        'Regola la soglia per affinare: più bassa rimuove più sfondo chiaro (line-art); più alta mantiene più zone chiare.',
    VectorizeCancel: 'Annulla',
    VectorizeFailed: 'La vettorializzazione non è riuscita. Riprova o cambia immagine.',
    Before: 'Prima',
    After: 'Dopo',
    VariableText: 'Testo variabile',
    VariableTextIntro:
        'Questa funzione somiglia a un mailing e ti permette di ottenere il tuo prodotto stampato in un unico esemplare per ogni testo; la quantità è calcolata automaticamente per il tuo carrello.',
    VariableTextData: 'Dati (una riga = un esemplare)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importa un CSV / Excel',
    SessionImages: 'Immagini importate',
    Accept: 'Accetta',
    UploadConsentMessage:
        'Confermo che nessuno dei miei file viola le leggi vigenti, i diritti d\'autore o i diritti di terzi.',
    VariableTextNoData: 'Aggiungi almeno una riga per l\'anteprima.',
    VdpFields: 'Campi variabili',
    VdpFieldName: 'Nome del campo',
    VdpPlace: 'Posiziona',
    VdpPlaced: 'Posizionato',
    VdpAddField: 'Aggiungi un campo',
    VdpAddRow: 'Aggiungi una riga',
    VdpLine: 'Riga',
    VdpEnterData: 'Inserisci i miei dati',
    Done: 'Fatto',
    VdpFieldStyle: 'Stile del campo',
    VdpFirstRowHeader: '1a riga = intestazione (nomi dei campi)',
    VdpQuantity: 'Quantità: {qty}',
    VdpQuantityHint: 'La quantità è imposta dal numero di righe del tuo testo variabile.',
    VariableTextOnlyOne: 'Un solo campo di testo variabile per creazione.',
    VariableTextEmptyFile: 'File vuoto o senza colonna utilizzabile.',
    VariableTextImportError: 'Impossibile leggere questo file. Usa un CSV o incolla il testo.',
    VariableTextExcelUnavailable: 'Lettura Excel non disponibile. Esporta in CSV o incolla il testo.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks:
        'Inchiostri selezionati: {chosen}/{required}. Scegli tutti gli inchiostri prima di confermare.',
    PreflightScreenColorCount: 'Serigrafia: la tua creazione è limitata a {count} inchiostro/i.',
    PreflightMinStroke: 'Spessore minimo del tratto consigliato: {mm} mm. I tratti più sottili possono stampare male.',
    PreflightMinFont: 'Dimensione minima del carattere consigliata: {pt} pt.',
    PreflightLaserMonochrome: 'Incisione laser: il risultato finale sarà monocromatico.',
    More: 'Altri',
    All: 'Tutti',
    AllCategories: 'Tutte le categorie',
    SearchCategory: 'Cerca una categoria…',
    NoProductAvailable: 'Nessun prodotto in questa categoria.',
    ChooseProductTitle: 'Scegli il tuo prodotto da personalizzare',
    PrintMethodQuestion: 'Come vuoi stampare il tuo {product}?',
    PrintMethodIntro:
        'Ogni metodo ha i suoi punti di forza e i suoi limiti: definisce i colori e le finiture disponibili in seguito.',
    StartLabel: 'Punto di partenza',
    StartTitle: 'Parti da un tema o da una pagina bianca',
    StartIntro: 'Un tema = un design pronto da ritoccare (il più rapido). Pagina bianca = controllo totale.',
    StepProduct: 'Prodotto',
    StepMethod: 'Metodo',
    StepStart: 'Inizio',
    StepDesign: 'Design',
    ChangeTheme: 'Cambia tema',
    BackToTheme: 'Torna al tema',
    Recent: 'Recenti',
    WhiteNotPrintable: 'Il bianco non è stampabile (trasparente).',
    LoginToSave: 'Accedi per ritrovare i tuoi progetti nel tuo account.',
    Login: 'Accedi',
    LoggingIn: 'Accesso in corso…',
    ContinueWithoutAccount: 'Continua senza account',
    SaveEmailPlaceholder: 'Il tuo indirizzo email',
    SaveEmailHint: 'Riceverai un link per riprendere il tuo progetto (conservato 30 giorni).',
    SaveConfirmTitle: 'Progetto salvato',
    SaveConfirmMessage:
        'Il tuo progetto è stato salvato. Ti abbiamo appena inviato un\'email con il link per riprenderlo.',
    DisableEmbroideryEffect: 'Disattiva effetto ricamo',
    AddThread: 'Aggiungi un filo',
    RemoveThread: 'Rimuovi un filo',
    VectorizeDenoise: 'Riduci il rumore',
    VectorizeDenoiseHint: 'Rimuove macchie e piccoli puntini indesiderati.',
    VectorizeSmoothing: 'Levigatura',
    VectorizeSmoothingHint: 'Arrotonda i contorni (meno angoli).',
    ZoomIn: 'Ingrandisci',
    ZoomOut: 'Riduci',
    Fit: 'Adatta',
    Apply: 'Applica',
    Edit: 'Modifica',
    Support: 'Assistenza',
    VectorizeAcknowledge:
        'Capisco di essere responsabile del controllo del risultato della vettorizzazione e che la stampa lo rispecchierà.',
    Crop: 'Ritaglia',
    Font: 'Carattere',
    Style: 'Stile',
    Outline: 'Contorno',
    Steps: 'Passaggi',
    Tools: 'Strumenti',
    ThemeColors: 'Colori',
    Minimize: 'Riduci a icona',
    MoveLayerUp: 'Sposta livello su',
    MoveLayerDown: 'Sposta livello giù',
    DragLayer: 'Trascina per riordinare',
    NoResult: 'Nessun risultato',
    SearchElement: 'Cerca un elemento…',
    ExpertMode: 'Modalità esperto',
    Finish: 'Termina',
    ChooseImageOrPhoto: 'Scegli un\'immagine o una foto',
    WizardIntro: 'Segui i passaggi per una creazione personalizzata in 1 minuto.',
    WizardIntroExpert: 'Vuoi più libertà? Passa alla modalità esperto.',
    ClickToChooseImage: 'Clicca qui per scegliere un\'immagine o una foto',
    ChooseCategoryDesc: 'Seleziona una famiglia di prodotti per iniziare.',
    SelectProductDesc: 'Seleziona un prodotto per iniziare…',
    FinalReview: 'Ultimo passaggio',
    StartWithThemeDesc: 'Parti da un design preconfigurato.',
    WithModelDesc: 'Scegli un modello già pronto.',
    ExpertModeConfirmTitle: 'Modalità esperto',
    ExpertModeConfirmMsg:
        'Passare alla modalità esperto è una scelta definitiva. Questa modalità è un po\' più complessa da usare, ma consente di aggiungere e modificare gli elementi senza vincoli.',
    ExpertModeHint: 'Completa la tua creazione senza limiti: aggiungi testi e foto come preferisci.',
    VariableData: 'Dati variabili',
    PhotoFrame: 'Cornice foto',
    PhotoFrameHint: 'Scegli una forma, poi inserisci una foto al suo interno.',
    PhotoFrameChooseShape: '1. Forma della cornice',
    PhotoFrameChangeShape: 'Cambia forma',
    PhotoFramePickPhoto: 'Scegli una foto',
    FromLibrary: 'Dalla libreria',
    VdpMaxRowsReached: 'Stock massimo raggiunto',
    VdpImportTruncated: 'Importazione limitata allo stock disponibile',
    LetterSpacing: 'Spaziatura tra lettere',
    OutlineActive: 'Contorno attivato',
    OutlineThickness: 'Spessore del contorno',
    AlignLeft: 'Allinea a sinistra',
    AlignCenter: 'Centra',
    AlignRight: 'Allinea a destra',
    Uppercase: 'Maiuscole',
    TextFormatting: 'Formattazione',
    FontSizeLabel: 'Dimensione carattere',
    SelectionActions: 'Azioni sulla selezione',
    DragToMove: 'Trascina per spostare',
    DragToResize: 'Trascina per ridimensionare',
    DragToRotate: 'Trascina per ruotare',
    MoveUpOneLevel: 'Sposta su di un livello',
    MoveDownOneLevel: 'Sposta giù di un livello',
    BringToFront: 'Porta in primo piano',
    Front: 'Primo piano',
    SendToBack: 'Porta in secondo piano',
    BackgroundNeverUnderPattern: 'Sfondo (mai sotto un motivo di sfondo)',
    EyedropperColor: 'Contagocce colore',
    PresetColors: 'Colori predefiniti',
    RecentColors: 'Colori recenti',
    Palette: 'Tavolozza',
    HexValue: 'Valore esadecimale',
    AiResultsHint: 'Trova tutti i suggerimenti nella scheda Immagine',
    Notifications: 'Notifiche',
    Zoom: 'Zoom',
    GuidedCustomization: 'Personalizzazione guidata',
    Actions: 'Azioni',
    InkAssistantYourChoice: 'Hai scelto:',
    InkAssistantCorrectQuestion: 'Vuoi correggere questa scelta?',
    ZonePrices: 'Prezzo per zona',
    ZonePriceApplied: 'Applicato',
    ZonePriceUncovered: 'Nessuna opzione copre tutte le zone decorate.',
    ZonePricesShow: 'Mostra',
    ZonePricesHide: 'Nascondi',
    '': ''
};
